const tone = (score) => {
  if (score >= 75) return { text: "text-emerald-600", bar: "bg-emerald-500", bg: "bg-emerald-50", border: "border-emerald-200" };
  if (score >= 50) return { text: "text-amber-600", bar: "bg-amber-500", bg: "bg-amber-50", border: "border-amber-200" };
  return { text: "text-red-600", bar: "bg-red-500", bg: "bg-red-50", border: "border-red-200" };
};

// Format: integers stay clean (87), decimals show only when non-zero (87.3).
const formatScore = (n) => {
  const v = Number(n) || 0;
  return Number.isInteger(v) ? String(v) : v.toFixed(1);
};

/**
 * `score` is the composite ranking score (AI score + bonuses).
 * Pass `aiScore` separately when you want to show the original AI judgement
 * as a subtle subtitle (used in the candidate card to keep both visible).
 */
const ScoreIndicator = ({ score = 0, aiScore, compact = false, tooltip }) => {
  const t = tone(score);
  if (compact) {
    return (
      <div
        data-testid="score-indicator-compact"
        className={`inline-flex items-center px-2 py-0.5 rounded-md border ${t.bg} ${t.border} shrink-0`}
        title={tooltip}
      >
        <span className={`heading text-xs font-bold tabular-nums leading-none ${t.text}`}>
          {formatScore(score)}%
        </span>
      </div>
    );
  }
  return (
    <div data-testid="score-indicator" className="w-full" title={tooltip}>
      <div className="flex items-baseline justify-between mb-1.5">
        <span className={`heading text-2xl font-bold tabular-nums ${t.text}`}>
          {formatScore(score)}
          <span className="text-sm font-medium ml-0.5">%</span>
        </span>
        <span className="text-xs text-slate-500 uppercase tracking-wider">ranking</span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-1.5 overflow-hidden">
        <div
          className={`h-1.5 rounded-full transition-all duration-500 ${t.bar}`}
          style={{ width: `${Math.min(100, Math.max(0, score))}%` }}
        />
      </div>
      {typeof aiScore === "number" && Math.round(aiScore * 10) !== Math.round(score * 10) && (
        <div className="text-[10px] text-slate-400 mt-0.5 tabular-nums">
          IA: {aiScore} · penalidade: {(score - aiScore).toFixed(1)}
        </div>
      )}
    </div>
  );
};

export default ScoreIndicator;
